import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface ToolCardProps {
  name: string;
  description: string;
  href: string;
  category?: string;
  badge?: string;
}

export const ToolCard = ({
  name,
  description,
  href,
  category,
  badge,
}: ToolCardProps) => {
  return (
    <Link to={href} className="group block h-full">
      <article className="relative flex h-full flex-col justify-between overflow-hidden border border-foreground/50 rounded-lg bg-card p-6 transition-all duration-200 hover:border-foreground/30 hover:shadow-sm group-hover:-translate-y-0.5">
        {/* Top section with category and badge */}
        <div className="space-y-4">
          <div className="flex items-center justify-between gap-2">
            {category && (
              <span className="inline-flex items-center rounded-sm bg-secondary px-2 py-1 text-[0.65rem] font-medium uppercase tracking-[0.12em] text-text-secondary">
                {category}
              </span>
            )}
            {badge && (
              <span className="inline-flex items-center justify-center rounded-full border border-foreground/20 bg-background px-2.5 py-0.5 text-[0.6rem] font-semibold tracking-wider text-foreground/70">
                {badge}
              </span>
            )}
          </div>

          {/* Title and description */}
          <div className="space-y-2">
            <h2 className="font-serifAccent text-lg tracking-tight text-foreground transition-colors group-hover:text-foreground/80">
              {name}
            </h2>
            <p className="text-sm leading-relaxed text-text-secondary line-clamp-2">
              {description}
            </p>
          </div>
        </div>

        {/* CTA with arrow */}
        <div className="mt-5 flex items-center gap-2 text-sm font-medium text-foreground transition-all">
          <span className="border-b border-transparent group-hover:border-foreground/40">
            Open tool
          </span>
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
        </div>
      </article>
    </Link>
  );
};
